import UserAttributes from "./UserAttributes";

const UserFullName = () => {
  const userAttributes = UserAttributes();

  if (userAttributes != null) {
    const firstName = userAttributes["given_name"];
    const lastName = userAttributes["family_name"];
    return firstName + " " + lastName;
  } else {
    return null;
  }
};

export default UserFullName;
